import { render, staticRenderFns } from "./imagens.vue?vue&type=template&id=37cbe841&scoped=true&"
import script from "./imagens.vue?vue&type=script&lang=js&"
export * from "./imagens.vue?vue&type=script&lang=js&"
import style0 from "./imagens.vue?vue&type=style&index=0&id=37cbe841&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cbe841",
  null
  
)

export default component.exports